<template>
  <mt-popup v-model="conf.isOpen" popup-transition="popup-fade" :modal=false class="previewModel">
    <div class="main">
      <iframe :src="conf.previewSrc" frameborder="0" ref="iframeBox"></iframe>
    </div>

    <a href="javascript:;" class="quit-btn" ref="quitBtn"
       :style="{'top': dragQuitConf.close.quitBtnTop + 'px', 'left': dragQuitConf.close.quitBtnLeft + 'px'}"
       @touchstart="dragToolBar('close').touchStart()" @touchmove.prevent="dragToolBar('close').touchMove()"
       @click="close">
    </a>

    <a href="javascript:;" class="share-btn" ref="shareBtn"
       v-if="perfectApp() && conf.type === 'game'"
       :style="{'top': dragQuitConf.share.quitBtnTop + 'px', 'right': dragQuitConf.share.quitBtnLeft + 'px','width':(getS() / 960*60)+ 'px','height':(getS() / 960*72)+ 'px'}"
       @click="comMethods.appShare(conf.previewSrc)">
    </a>
  </mt-popup>
</template>

<script>
  import store from '../store/store';
  import {Methods} from '../const/common';

  export default {
    name: "open_link",
    props: ['conf'],
    store,
    data() {
      return {
        dragQuitConf: {
          close: this.initDragQuitConf(20),
          share: this.setShareSite()
        },
        comMethods: Methods
      }
    },
    methods: {
      getS(){
        return document.body.clientHeight;
      },
      close() {
        this.$emit('close');
        Methods.checkChapterHash(90);
      },
      setShareSite() {
        var _width = document.body.clientHeight / 960 * 540,
          _site = ((document.body.clientWidth - _width) / 2) + (20*document.body.clientHeight / 960);

        return this.initDragQuitConf(_site, 80)
      },
      perfectApp() {
        if (window.org_box) {
          return Methods.boxVerJudge('abox', 234);
        }
        if (window.iOSinfo) {
          return Methods.boxVerJudge('ibox', '2.11.0425');
        }
      },
      initDragQuitConf(startX, startY) {
        return {
          quitBtnTop: startY || startX,
          quitBtnLeft: startX,
          touchInfo: null,
          dx: 0,
          dy: 0,
          nowAxisX: 0,
          nowAxisY: 0
        }
      },
      dragToolBar(type) {
        var btn = type === 'close'? this.$refs.quitBtn: this.$refs.shareBtn, quitSize = btn.clientWidth,
          newAxis = {x: 0, y: 0}, _conf = this.dragQuitConf[type],
          windowWidth = document.documentElement.clientWidth,
          windowHeight = document.documentElement.clientHeight;

        this.isOutSide = function () {
          _conf.dx = btn.offsetLeft + quitSize;
          _conf.dy = btn.offsetTop + quitSize;

          if (_conf.dx > windowWidth) {
            _conf.quitBtnLeft = windowWidth - quitSize;
          } else if (_conf.dy > windowHeight) {
            _conf.quitBtnTop = windowHeight - quitSize;
          }
        };
        this.touchStart = function () {
          _conf.touchInfo = this.touchPoint();
          _conf.nowAxisX = _conf.touchInfo.clientX;
          _conf.nowAxisY = _conf.touchInfo.clientY;
          _conf.dx = btn.offsetLeft;
          _conf.dy = btn.offsetTop;
        };
        this.touchMove = function () {
          _conf.touchInfo = this.touchPoint();
          newAxis.x = _conf.dx + (_conf.touchInfo.clientX - _conf.nowAxisX);          // 新距离
          newAxis.y = _conf.dy + (_conf.touchInfo.clientY - _conf.nowAxisY);
          newAxis.x = newAxis.x < 0 ? 0 : newAxis.x;                                   // 防止出界
          newAxis.y = newAxis.y < 0 ? 0 : newAxis.y;
          newAxis.x = (newAxis.x > windowWidth - quitSize ? windowWidth - quitSize : newAxis.x);
          newAxis.y = (newAxis.y > windowHeight - quitSize ? windowHeight - quitSize : newAxis.y);

          _conf.quitBtnTop = newAxis.y;
          _conf.quitBtnLeft = newAxis.x;
        };
        this.touchPoint = function () {
          if (event.touches) {
            _conf.touchInfo = event.touches[0];
          } else {
            _conf.touchInfo = event;
          }
          return _conf.touchInfo;
        };
        return this;
      },
      mounted() {
        var _this = this;

        window.onresize = function () {
          _this.dragToolBar().isOutSide();
        };
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/open_link.css";
</style>



// WEBPACK FOOTER //
// src/components/open_link.vue